import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  violations: null,
  success: false,
  error: false
};

const EventSongVoteSlice = createSlice({
  name: "EventSongVote",
  initialState,
  reducers: {
    eventSongVoteSuccess(state, action) {
      state.success = true;
    },
    eventSongVoteError(state, action) {
      state.violations = action.payload;
      state.error = true;
    },
    eventSongVoteReset(state) {
      state.success = false;
      state.violations = null
      state.error = false
    },
  },
});

export const {
  eventSongVoteSuccess,
  eventSongVoteError,
  eventSongVoteReset,
} = EventSongVoteSlice.actions

export default EventSongVoteSlice.reducer;
